// Google Analytics 4 loader. Plain module (no React) so it stays testable and free of UI concerns.
// Called only after the visitor accepted cookies: nothing here runs, and nothing is requested from
// Google, before that (WEB-3).

const GTAG_SRC = 'https://www.googletagmanager.com/gtag/js'

let started = false

// The measurement ID comes only from the build environment (Netlify env variable); null when unset.
export function getMeasurementId() {
  return import.meta.env.VITE_GA4_MEASUREMENT_ID || null
}

function gtag() {
  // gtag.js expects the Arguments object itself, not an array copy.
  window.dataLayer.push(arguments)
}

// Idempotent: a second Accept, a second tab's event or a StrictMode re-run adds nothing.
export function startGa4(id) {
  if (started || !id || typeof window === 'undefined') return
  started = true
  if (document.querySelector('script[data-ga4]')) return

  window.dataLayer = window.dataLayer || []
  window.gtag = gtag

  gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  })
  gtag('consent', 'update', {
    analytics_storage: 'granted',
    ad_storage: 'denied', // no ads on this site
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  })
  gtag('js', new Date())
  // Page views are sent explicitly per route (sendPageView), so the SPA never counts one twice.
  gtag('config', id, {
    anonymize_ip: true,
    cookie_flags: 'SameSite=None;Secure',
    send_page_view: false
  })

  const script = document.createElement('script')
  script.async = true
  script.src = `${GTAG_SRC}?id=${encodeURIComponent(id)}`
  script.dataset.ga4 = ''
  // Blocked or offline: no retry and no error; queued commands stay local. The next full load tries again.
  script.onerror = () => {}
  document.head.appendChild(script)
}

// True once startGa4 ran in this page (gtag.js requested). Decline then needs a reload (WEB-4).
export function isGa4Started() {
  return started || (typeof document !== 'undefined' && !!document.querySelector('script[data-ga4]'))
}

// Withdraw: block further hits, including unload beacons, and stop GA from rewriting its cookies.
export function stopGa4(id) {
  if (typeof window === 'undefined' || !id) return
  window[`ga-disable-${id}`] = true
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    })
  }
}

export function sendPageView({ path, title, location }) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
    page_location: location
  })
}
